var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.929 18C16.52 18 17 17.496 17 16.875v-4.5c0-.621-.48-1.125-1.071-1.125h-.536V9.562C15.393 7.598 13.87 6 12 6c-1.87 0-3.393 1.598-3.393 3.562v1.688h-.536C7.48 11.25 7 11.754 7 12.375v4.5C7 17.496 7.48 18 8.071 18h7.858zm-2.322-6.75h-3.214V9.562c0-.93.72-1.687 1.607-1.687.886 0 1.607.757 1.607 1.687v1.688z",
    fill: "#626971",
    fillRule: "nonzero"
  })));
}
export default __webpack_public_path__ + "static/media/cf33207be7835dca159413c9cb1a2f53-Lock.svg";
export { SvgLock as ReactComponent };